import React from 'react'
import { useNativeAuth, UseNativeAuthReturn } from '@mahendran/shared-frontend-config'
import type { AuthUser } from '../lib/api'

export type AuthContextValue = Omit<UseNativeAuthReturn, 'ready' | 'user'> & {
  initialized: boolean
  user: AuthUser | null
}

export const AuthContext = React.createContext<AuthContextValue | undefined>(undefined)

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useNativeAuth()

  const value = React.useMemo<AuthContextValue>(() => ({
    ...auth,
    initialized: auth.ready,
    user: auth.user as AuthUser | null,
  }), [auth])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  const ctx = React.useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
